import { createAsyncThunk } from "@reduxjs/toolkit";

export const removeApplication = createAsyncThunk<string, number>(
  "TMP_ACTION",
  () => {
    return Promise.resolve("ok");
  },
);
